import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useBooking } from '../contexts/BookingContext';
function getTimeLeft(target: Date) {
  const now = new Date().getTime();
  const diff = target.getTime() - now;
  if (diff <= 0) return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor(diff / (1000 * 60 * 60) % 24),
    minutes: Math.floor(diff / (1000 * 60) % 60),
    seconds: Math.floor(diff / 1000 % 60)
  };
}
const TARGET_DATE = new Date('2026-04-19T11:00:00');
export function WebinarBanner() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(TARGET_DATE));
  const {
    openBooking
  } = useBooking();
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft(TARGET_DATE));
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="bg-[#1a1a1a] text-white relative overflow-hidden" data-id="element-720">
      <div className="absolute inset-0 pointer-events-none" data-id="element-721">
        <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#3b7780] rounded-full mix-blend-screen filter blur-[120px] opacity-15" data-id="element-722"></div>
        <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-[#59d0d4] rounded-full mix-blend-screen filter blur-[120px] opacity-10" data-id="element-723"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 relative z-10" data-id="element-724">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-16 items-center" data-id="element-725">
          {/* Left Content */}
          <div className="lg:col-span-3" data-id="element-726">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-tight mb-6 tracking-tight" data-id="element-727">
              Kostenloses Webinar am Sonntag 19.04 um 11:00 Uhr. Melden Sie sich
              jetzt an.
            </h2>
            <p className="text-slate-400 font-medium text-base sm:text-lg leading-relaxed mb-8 max-w-2xl" data-id="element-728">
              Lernen Sie uns, die Erfolgsgeheimnisse einer der größten
              Zahnarztpraxen Deutschlands und das Curriculum unverbindlich
              kennen.
            </p>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-3 mb-4" data-id="element-729">
              <span className="flex items-center gap-2 text-sm sm:text-base font-bold" data-id="element-730">
                <span data-id="element-731">🏆</span> 78 CME Punkte
              </span>
              <span className="flex items-center gap-2 text-sm sm:text-base font-bold" data-id="element-732">
                <span data-id="element-733">👤</span> 2000+ Teilnehmer
              </span>
              <span className="flex items-center gap-2 text-sm sm:text-base font-bold" data-id="element-734">
                <span data-id="element-735">🔬</span> Live OPs &amp; Hands On
              </span>
            </div>
            <span className="flex items-center gap-2 text-sm sm:text-base font-bold" data-id="element-736">
              <span data-id="element-737">⭐</span> DGÄZ zertifiziert
            </span>
          </div>

          {/* Right Content */}
          <div className="lg:col-span-2 flex flex-col items-center lg:items-end gap-6" data-id="element-738">
            <p className="text-white font-bold text-sm flex items-center gap-2" data-id="element-739">
              <span className="w-2 h-2 rounded-full bg-[#59d0d4] inline-block" data-id="element-740"></span>
              Sofort umsetzbare Einblicke
            </p>

            {/* Countdown */}
            <div className="flex items-end gap-4 sm:gap-6" data-id="element-741">
              {[{
              value: timeLeft.days,
              label: 'Tage'
            }, {
              value: timeLeft.hours,
              label: 'Stunden'
            }, {
              value: timeLeft.minutes,
              label: 'Minuten'
            }, {
              value: timeLeft.seconds,
              label: 'Sekunden'
            }].map(item => <div key={item.label} className="flex flex-col items-center" data-id="element-742">
                  <span className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight tabular-nums" data-id="element-743">
                    {pad(item.value)}
                  </span>
                  <span className="text-[11px] sm:text-xs text-slate-400 font-semibold mt-1 uppercase tracking-wider" data-id="element-744">
                    {item.label}
                  </span>
                </div>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col gap-3 w-full max-w-xs" data-id="element-745">
              <Link to="/kontakt" className="flex flex-col items-center justify-center px-6 py-4 bg-[#59d0d4] hover:bg-[#4abfc3] text-slate-900 font-bold rounded-xl transition-all hover:scale-105 shadow-lg text-center" data-id="element-746">
                <span className="text-base font-extrabold" data-id="element-747">
                  Kostenloses Webinar
                </span>
                <span className="text-xs font-semibold opacity-80 mt-0.5" data-id="element-748">
                  Sonntag 19. April um 11:00 Uhr
                </span>
              </Link>
              <button onClick={openBooking} className="flex flex-col items-center justify-center px-6 py-4 bg-white hover:bg-slate-100 text-slate-900 font-bold rounded-xl transition-all hover:scale-105 shadow-lg text-center border border-slate-200" data-id="element-749">
                <span className="text-base font-extrabold" data-id="element-750">
                  Jetzt zum nächsten Kurs anmelden
                </span>
                <span className="text-xs font-semibold text-slate-500 mt-0.5" data-id="element-751">
                  Kurs auswählen und durchstarten
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}